import Vue from 'vue'
import VueRouter from 'vue-router'

import Default from '../Layouts/Default.vue'

import StatesVie from '../views/StatesVie.vue'
import Home from '../components/Home.vue'

Vue.use(VueRouter)

 

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:[
    {
      path: '/',
      component: Default,
      children:[
        {

          path:'/(home)*',
          name:'Home',
          component: Home
        },
        { 
    
          path: '/states',
          name: 'states',
          component: StatesVie,
        
          
        }
      ]
      
    },
   ]
})

export default router
